import React, { FC } from 'react';
import styled from 'styled-components';

import Text from '../Text';

const Container = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 0 24px;
  overflow: hidden;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  height: fit-content;
  max-width: 480px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  align-self: center;
`;

const CustomIlustration = styled.div`
  margin-bottom: 16px;
`;

const Description = styled(Text)`
  margin: 0;
  font-size: 12px;
  color: ${p => p.theme.colors.gra600};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

interface InnerEmptyProps {
  icon: any;
  text: string;
  customIlustration?: React.ReactNode;
  'data-testid'?: string;
}

const InnerEmpty: FC<InnerEmptyProps> = ({
  icon,
  text,
  customIlustration,
  'data-testid': dataTestId = 'empty'
}) => (
  <Container data-testid={dataTestId}>
    <Content>
      {!customIlustration && icon && icon}
      {customIlustration && (
        <CustomIlustration>{customIlustration}</CustomIlustration>
      )}
      <Description>{text}</Description>
    </Content>
  </Container>
);

export default InnerEmpty;
